export default "__VITE_ASSET__yHnM0aV6__"